
import VueNumeric from "vue-numeric";
import { Component, Vue } from "vue-property-decorator";
import { API_STORE } from "@/config";
import Modal from "@/views/modal/Modal.vue";
import Axios from "axios";
import { getAPIAuthorizedHeader } from "@/services/common";
import ScrollPaginationMixin from "@/mixins/Pagination.mixin";
import { mixins } from "vue-class-component";
import { OPERATOR_TYPE } from "@/constant";

@Component({ components: { Modal, VueNumeric } })
export default class APIComponent extends mixins(ScrollPaginationMixin) {
  public margins = [];
  public operatorTypes = OPERATOR_TYPE;
  public isMarginListEmpty = true;
  public operatorType = null;

  action(marginId, actionName) {
    this.margins.forEach((margin) => {
      if (margin.providerId == marginId) {
        margin.editable = actionName == "edit" ? true : false;
        margin.showError = false;
      } else {
        margin.editable = false;
        margin.showError = false;
      }
    });
    this.margins = JSON.parse(JSON.stringify(this.margins));
  }
  public onSearchString() {
      this.paginationConfig.currentPage = 1;
      this.getMargins();
  }

  public onPageChange(page) {
    this.paginationConfig.currentPage = page;
    this.getMargins();
  }
  public enableError(marginId) {
    this.margins.forEach((margin) => {
      if (margin.providerId == marginId) margin.showError = true;
    });
    this.margins = JSON.parse(JSON.stringify(this.margins));
  }

  public async updateAPIMargin(marginId) {
      let margin = this.margins.find((a) => a.providerId == marginId);
      if (margin.serviceType && margin.superAdminShare != 0) {
        let obj = {
          apiOperatorCodeId: marginId,
          adminShare: margin.adminShare,
          superAdminShare: margin.superAdminShare,
          serviceType: margin.serviceType,
          flat: margin.flat,
        };
        let result = await Axios.post(
          API_STORE.PORTAL + "updateAPIMargin",
          obj,
          {
            headers: getAPIAuthorizedHeader(),
          }
        );
        this.$snotify.success(result.data.message);
        if (result) this.getMargins();
      } else {
        this.enableError(marginId);
      }
  }
  public onChangeOperatorType() {
    this.paginationConfig.currentPage = 1;
    this.getMargins();
  }

  public async getMargins() {
      this.asyncPageLoader = true;
      let obj = {
        searchString: this.searchString,
        limit: this.paginationConfig.pageLimit,
        page: this.paginationConfig.currentPage,
        subdomain: null,
        operatorType: this.operatorType,
      };
      let response = await Axios.get(API_STORE.PORTAL + "getMargins", {
        params: obj,
        headers: getAPIAuthorizedHeader(),
      });
      this.asyncPageLoader = false;
      if (response && response.data && response.data.docs) {
        this.paginationConfig.totalPages = response.data.totalPages;
        this.paginationConfig.totalLength = response.data.totalDocs;
        this.margins = response.data.docs.map((a) => {
          a["editable"] = false;
          a["showError"] = false;
          return a;
        });
        if (this.margins.length > 0 && this.counter == 0) {
          this.counter++;
          this.isMarginListEmpty = false;
        }
      }
  }

  async created() {
    this.getMargins();
  }
}
